import Http from '@/services/httpAgency'

// Full admin report for a showcase edition
export const showcaseReportFull = (showcaseId) =>
	Http.get(`/showcases/${showcaseId}/report`)

// Operational editorial coverage hub: package, priority, delivery and keys.
export const showcaseCoverageHub = (showcaseId, params = {}) =>
	Http.get(`/showcases/${showcaseId}/coverage-hub`, { params })

// Studio-specific report (what the studio sees)
export const showcaseReportStudio = (showcaseId, submissionId) =>
	Http.get(`/showcases/${showcaseId}/report/studio/${submissionId}`)

// List all studios (submissions) for email selection
export const showcaseReportStudios = (showcaseId) =>
	Http.get(`/showcases/${showcaseId}/report/studios`)

// Send report emails to selected studios
export const showcaseReportSend = (showcaseId, params) =>
	Http.post(`/showcases/${showcaseId}/report/send`, params)

// Key campaigns for a showcase
export const showcaseKeys = (showcaseId) =>
	Http.get(`/showcases/${showcaseId}/keys`)

// Create key campaign from submission
export const showcaseCreateKeyCampaign = (showcaseId, params) =>
	Http.post(`/showcases/${showcaseId}/keys`, params)

// Add key codes to a campaign
export const showcaseAddKeys = (showcaseId, keyId, params) =>
	Http.post(`/showcases/${showcaseId}/keys/${keyId}/add-keys`, params)

// Get redemption details for a key campaign
export const showcaseKeyRedemptions = (showcaseId, keyId) =>
	Http.get(`/showcases/${showcaseId}/keys/${keyId}/redemptions`)
